import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container } from '@mui/material';

/**
 * MinimalLayout - Simple layout for authentication pages
 * No sidebar, just centered content
 */
const MinimalLayout: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        background: `
          linear-gradient(135deg, #667eea 0%, #764ba2 100%),
          linear-gradient(45deg, #f093fb 0%, #f5576c 100%),
          linear-gradient(225deg, #4facfe 0%, #00f2fe 100%)
        `,
        backgroundSize: '400% 400%',
        animation: 'gradientShift 15s ease infinite',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          // bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.3) 0%, transparent 50%)
          `,
          animation: 'floatingOrbs 20s ease-in-out infinite'
        },
        '@keyframes gradientShift': {
          '0%': { backgroundPosition: '0% 50%' },
          '50%': { backgroundPosition: '100% 50%' },
          '100%': { backgroundPosition: '0% 50%' }
        },
        '@keyframes floatingOrbs': {
          '0%, 100%': { transform: 'translateY(0px) rotate(0deg)' },
          '33%': { transform: 'translateY(-20px) rotate(120deg)' },
          '66%': { transform: 'translateY(10px) rotate(240deg)' }
        },
        padding: 2
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            bgcolor: 'white',
            borderRadius: 3,
            boxShadow: `
              0 8px 32px rgba(0, 0, 0, 0.15),
              0 4px 16px rgba(0, 0, 0, 0.1),
              inset 0 1px 0 rgba(255, 255, 255, 0.8)
            `,
            border: '1px solid rgba(0, 0, 0, 0.1)',
            padding: 4,
            position: 'relative',
            zIndex: 1
          }}
        >
          <Outlet />
        </Box>
      </Container>
    </Box>
  );
};

export default MinimalLayout;
